import React, { useEffect, useState } from 'react';
import Badge from 'react-bootstrap/Badge';
import { getAdminNewAccounts } from '../../services/ledgerService';
import { BackButton } from '../../components/BackButton';
import TimeWindowFilter, { useTimeWindow } from './TimeWindowFilter';
import './GameDetails.css';

const NewAccounts = () => {
    const { from, to } = useTimeWindow();
    const [accounts, setAccounts] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        let cancelled = false;
        setAccounts(null);
        setError(null);
        getAdminNewAccounts({ from, to })
            .then((body) => {
                if (cancelled) return;
                setAccounts(body.accounts || []);
            })
            .catch((err) => {
                if (cancelled) return;
                console.error('Failed to load new accounts', err);
                setError(err.message || 'Failed to load new accounts');
            });
        return () => { cancelled = true; };
    }, [from, to]);

    const formatDate = (dateString) => {
        const options = { year: 'numeric', month: 'long', day: 'numeric' };
        return new Date(dateString).toLocaleDateString(undefined, options);
    };

    return (
        <div className="game-details">
            <div className="detail-header">
                <BackButton to="/admin" />
                <h1>New Accounts</h1>
            </div>
            <TimeWindowFilter />
            {error ? (
                <p className="text-danger">Error: {error}</p>
            ) : accounts === null ? (
                <p className="empty-state">Loading...</p>
            ) : accounts.length === 0 ? (
                <p className="empty-state">No accounts created in this window.</p>
            ) : (
                <table>
                    <thead>
                        <tr>
                            <th>Joined</th>
                            <th>Name</th>
                            <th>Email</th>
                            <th>House</th>
                            <th>Sign-in</th>
                            <th>Verified</th>
                        </tr>
                    </thead>
                    <tbody>
                        {accounts.map((account) => (
                            <tr key={account.userId}>
                                <td>{formatDate(account.dateJoined)}</td>
                                <td>{account.name}</td>
                                <td>{account.email}</td>
                                <td>{account.houseName}</td>
                                <td>{account.authMethod === 'oidc' ? 'Google' : 'Password'}</td>
                                <td>
                                    {account.emailVerified
                                        ? <Badge bg="success">verified</Badge>
                                        : <Badge bg="secondary">unverified</Badge>}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        </div>
    );
};

export default NewAccounts;
